export const GOOGLE_API_CLIENT = 'https://apis.google.com/js/api:client.js';
export const GOOGLE_API = 'https://apis.google.com/js/api.js';
export const GOOGLE_IDENTITY_SERVICE = 'https://accounts.google.com/gsi/client';
